import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { formatISO, getHours, roundToNearestHours } from 'date-fns';
import { map, Observable } from 'rxjs';
import { enterFade, enterLeaveFast } from 'src/app/animations/common.animations';
import { ButtonComponent } from 'src/app/components/button/button.component';
import { HeadingComponent } from 'src/app/components/heading/heading.component';
import { ItemLabelComponent } from 'src/app/components/item-label/item-label.component';
import { ItemValueComponent } from 'src/app/components/item-value/item-value.component';
import { ItemComponent } from 'src/app/components/item/item.component';
import { SpinnerComponent } from 'src/app/components/spinner/spinner.component';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { DateChangerDirective } from 'src/app/directives/date-changer.directive';
import { IsoDateToStringPipe } from 'src/app/pipes/iso-date-to-string.pipe';
import { ClinicalDayService } from 'src/app/services/clinical-day.service';
import { SheetTemplatesService } from 'src/app/services/sheet-templates.service';
import { AppState } from 'src/app/store/reducers';
import { createSheetRequested } from 'src/app/store/sheet-graph/sheet-graph.actions';
import { SheetTemplate } from 'src/app/types/sheet.types';

@Component({
	templateUrl: './create-sheet.modal.html',
	styleUrl: './create-sheet.modal.scss',
	imports: [
		LetDirective, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, SpinnerComponent, HeadingComponent, ItemComponent,
		ItemLabelComponent, ItemValueComponent, SvgIconComponent, DateChangerDirective, IsoDateToStringPipe, ButtonComponent
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [enterFade, enterLeaveFast]
})
export class CreateSheetModal {

	@Input() visitId!: string;

	sheetTemplates$: Observable<SheetTemplate[]>;

	selectedTemplatId: string | null = null;
	selectedDate: string | null = null;

	private createSheetClicked: boolean = false; // without this, it is possible to click twice, causing an API race condition where two sheets could be created for a visit

	constructor(private sheetTemplatesService: SheetTemplatesService, private clinicalDayService: ClinicalDayService, private store: Store<AppState>, private modalController: ModalController) {
		this.sheetTemplates$ = this.sheetTemplatesService.getTemplates().pipe(
			map(templates => templates.filter(t => t.isActive))
		);
	}

	selectBlank() {
		this.selectedTemplatId = null;
		this.selectedDate = null;
	}

	selectTemplate(template: SheetTemplate) {
		this.selectedTemplatId = template.id;
		this.selectedDate = formatISO(roundToNearestHours(new Date(), { roundingMethod: 'floor' }));
	}

	dateSelected(value: string | null) {
		this.selectedDate = value!;
	}

	createSheet() {
		if (this.createSheetClicked) return;
		this.createSheetClicked = true;

		let fromDate = null;

		if (this.selectedDate) fromDate = this.clinicalDayService.hoursToClinicalDayIsoDateString(new Date(), getHours(this.selectedDate));

		this.store.dispatch(createSheetRequested({ visitId: this.visitId, templateId: this.selectedTemplatId, applyTemplateFrom: fromDate }));
		this.close();
	}

	close() {
		return this.modalController.dismiss();
	}
}
